import { BackSide, LineBasicMaterial, MeshBasicMaterial, MeshStandardMaterial } from 'three'
import Constants from '../lib/Constants'
import { HanddrawnMaterial } from '../lib/HanddrawnMaterial'

export default class Materials
{
    constructor(_options)
    {
        this.debug = _options.debug
        this.resources = _options.resources

        this.items = {}

        /**
         * Handdrawn Materials
         */
         this.items.treesMat = new HanddrawnMaterial(
        {
            resources: this.resources,
            baseColor: Constants.COLORS.map,
        })
        this.items.terrainMat = new HanddrawnMaterial(
        {
            resources: this.resources,
            baseColor: Constants.COLORS.map,
            colorMap: this.resources.items.fieldsTexture,
            colorMapOpacity: 0.65,
            opacityMap: this.resources.items.alphaTexture,
            colorMapOverlay: Constants.COLORS.paletteGreenLight,
            minOpacity: 0
        })
        this.items.lotMat = new HanddrawnMaterial(
        {
            resources: this.resources,
            baseColor: Constants.COLORS.lot,
            colorMap: this.resources.items.fieldsTexture,
            colorMapOverlay: Constants.COLORS.paletteGreen,
            colorMapOpacity: 1,
        })
        this.items.lotDisabledMat = new HanddrawnMaterial(
        {
            resources: this.resources,
            baseColor: Constants.COLORS.lot,
            colorMap: this.resources.items.fieldsTexture,
            colorMapOverlay: Constants.COLORS.paletteGreenLight,
            colorMapOpacity: 0.75
        })
        this.items.buildingMat = new HanddrawnMaterial(
        {
            resources: this.resources,
            baseColor: Constants.COLORS.building,
            minOpacity: 0,
            opacityMap: this.resources.items.alphaTexture
        })
        this.items.lakeMat = new HanddrawnMaterial(
        {
            resources: this.resources,
            baseColor: Constants.COLORS.paletteBlue,
        })
        this.items.lotHighlightedMat = new HanddrawnMaterial(
        {
            resources: this.resources,
            baseColor: Constants.COLORS.lot,
            colorMap: this.resources.items.fieldsTexture,
            colorMapOverlay: Constants.COLORS.highlightedLot,
        })
        this.items.plainHighlightedMat = new HanddrawnMaterial(
        {
            resources: this.resources,
            baseColor: Constants.COLORS.highlightedLot,
        })
        this.items.bottleMat = new HanddrawnMaterial(
        {
            resources: this.resources,
            colorMap: this.resources.items.bottleMalvaColorFonio,
            opacityMap: this.resources.items.bottleMalvaOpacity,
            minOpacity: 0.75,
        })

        /**
         * Line Materials
         */
         this.items.wireframeMat = new LineBasicMaterial(
        {
            color: Constants.COLORS.wireframe,
            linewidth: 1,
            transparent: true,
            opacity: 1
        })

        /**
         * Basic Materials
         */
         this.items.basicBlackMat = new MeshBasicMaterial({ color: 0x000000 })
         this.items.skyMat = new MeshBasicMaterial({ side: BackSide, transparent:true, opacity: 0.15, map: this.resources.items.clouds })

        /**
         * Debug
         */
        if(this.debug.overrideMaterials) this.debugOverride()
    }

    debugOverride()
    {
        const debugMaterial = new MeshStandardMaterial({ color: 0xffffff })
        for(let i in this.items)
        {
            this.items[i] = debugMaterial
        }
    }
}